import { Button, Card, CardContent, FormField } from '@/components/ui';
import { useAppDispatch, useAppSelector } from '@/config/store';
import { Form } from '@/shared/form';
import { useEffect } from 'react';
import { Translate } from 'react-jhipster';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { z } from 'zod';
import { PasswordResetState, handlePasswordResetInit, reset } from '../password-reset.reducer';

const schema = z.object({
  email: z
    .string()
    .min(1, "Il campo non devve essere vuoto.")
    .min(5, "L'email deve essere lunga almeno 5 caratteri.")
    .max(50, "La tua email non può essere lunga più di 50 caratteri.")
    .email("La tua email non è valida."),
});

type FormValues = z.infer<typeof schema>;

export const PasswordResetInit = () => {
  const dispatch = useAppDispatch();
  const { successMessage, resetPasswordSuccess, loading } = useAppSelector<PasswordResetState>(
    (state) => state.passwordReset
  );

  const handleValidSubmit = (data: FormValues) => {
    dispatch(handlePasswordResetInit(data.email));
  };

  useEffect(
    () => () => {
      dispatch(reset());
    },
    [dispatch]
  );

  useEffect(() => {
    if (successMessage) toast.success(successMessage);
  }, [successMessage]);

  const successMessageBox = () => (
    <p className="mb-2 text-[var(--color-mockup-text-mid)]">
      <Translate contentKey="reset.request.messages.success" />
    </p>
  );

  const emailForm = () => (
    <>
      <p className="mb-2 text-[var(--color-mockup-text-mid)]">
        <Translate contentKey="reset.request.messages.info" />
      </p>
      <Form schema={schema} onSubmit={handleValidSubmit} defaultValues={{ email: '' }}>
        <div className="space-y-4">
          <FormField name="email" label="Email" autoComplete="email" required autoFocus />
          <Button type="submit" className="w-full" disabled={loading}>
            {loading ? '...' : <Translate contentKey="reset.request.form.button" />}
          </Button>
        </div>
      </Form>
    </>
  );

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <Card className="max-w-[800px] overflow-hidden text-[var(--color-mockup-text-mid)]">
        <div className="grid grid-rows-[min-content_auto_min-content]">
          <header className="border-b border-[var(--color-mockup-border)]">
            <div className="flex flex-wrap items-center justify-between gap-3 p-4">
              <h1 className="text-xl font-medium text-[var(--color-mockup-text)]">
                <Translate contentKey="reset.request.title" />
              </h1>
            </div>
          </header>
          <CardContent className="p-5">
            {resetPasswordSuccess ? successMessageBox() : emailForm()}
            <div className="mt-6 text-center">
              <p className="text-sm text-[var(--color-mockup-text-light)]">
                <Link to="/login" className="text-primary hover:underline">
                  Torna alla pagina principale
                </Link>
              </p>
            </div>
          </CardContent>
        </div>
      </Card>
    </div>
  );
};

export default PasswordResetInit;
